import { render } from "./Officer.vue?vue&type=template&id=6e579ae6&scoped=true&ts=true"
import script from "./Officer.ts?vue&type=script&lang=ts"
export * from "./Officer.ts?vue&type=script&lang=ts"

import "./Officer.scss?vue&type=style&index=0&id=6e579ae6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e579ae6"]])

export default __exports__